<template>
  <div class="testimonialButton"></div>
</template>

<script>
export default {};
</script>

<style scoped>
.testimonialButton {
  display: block;
  float: left;
  flex-direction: row;
  width: 4rem;
  height: 0.5rem;
  background-color: #00c5fd;
  margin: 0.25rem;
}

@media (max-width: 768px) {
  .testimonialButton {
    width: 3rem;
  }
}

.testimonialButton:hover {
  background-color: white;
  cursor: pointer;
}
</style>
